export default __webpack_public_path__ + "static/media/@3x_case_1(780_830).f2114280.png";